import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const ImageContainer = styled.div`
  margin: -10px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
`;
export const ImageWrapper = styled.div<{ imagesAmount: number }>`
  ${(props) => {
    if (props.imagesAmount <= 6) {
      return { width: '33%', height: '240px' };
    }

    if (props.imagesAmount > 6 && props.imagesAmount <= 12) {
      return { width: '25%', height: '180px' };
    }

    return { width: '20%', height: '120px' };
  }};

  padding: 10px;
  padding-bottom: 10px;

  ${mediaQuery('phone')} {
    width: 50%;
  }
`;
